import React from 'react';
import { Box, Grid } from '@material-ui/core/index';
import TextField from './TextField';


interface Props {
    search: string,
    label: string,
    setSearch: (search: string) => void,
    searchKey: string,
    options: any[],
    onOptionSelected: (option: any) => void,
    renderOption: (option: any, onOptionSelected: () => void) => React.ReactNode,
}

const SearchableList = ({
  search,
  setSearch,
  label,
  searchKey,
  options,
  onOptionSelected,
  renderOption,
}: Props) => (
  <Box display="flex" flexDirection="column">
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <TextField
          onChange={(e: any) => setSearch(e.target.value)}
          value={search}
          label={label}
          fullWidth
        />
      </Grid>
      {
        options
          .filter((option) => option[searchKey].toLowerCase().includes(search.toLowerCase()))
          .map((option) => (
            <Grid item xs={12} key={option[searchKey]}>
              {renderOption(option, () => onOptionSelected(option))}
            </Grid>
          ))
        }
    </Grid>
  </Box>
);

export default SearchableList;
